// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OVtii{min-height:100vh;background:#fff}.OVtii.n8EgC{height:100dvh;min-height:0;overflow:hidden;background:#f4f4f7}.BysS9{margin:0 auto;display:flex;width:100%;max-width:1400px;padding:80px 64px;gap:40px;box-sizing:border-box}.BysS9.snM2k{flex-direction:column;padding:16px;gap:16px;height:100%;box-sizing:border-box;position:relative;padding-top:80px}.tH4d7{position:absolute;top:0;left:0;right:0;z-index:10}.USkPP{flex:1;min-width:0;background:#fff}.Erj_x{width:100%;flex:1;min-height:0;display:flex;flex-direction:column;background:#fff;border-radius:12px;padding:16px;box-sizing:border-box}.eAoXL{flex:1;min-width:0;background:#f4f4f7;border:1px solid #d4d4e0;border-radius:8px;padding:24px;padding-bottom:16px;display:flex;flex-direction:column;justify-content:space-between}.eAoXL.RAb5u{width:100%;flex:1;min-height:0;overflow:auto;background:transparent;border:none;border-radius:0;padding:0}.KOXbp{display:flex;flex-direction:column;gap:16px;flex:1;min-height:0}.AjPTn{margin:0}.h0cTt{width:100%}.h0cTt [class*=optionBgClientOnboarding],.h0cTt [class*=boxClientOnboarding],.h0cTt [class*=bgClientOnboarding],.h0cTt [class*=inputNewUi],.h0cTt [class*=addAnotherSheetOption]{background-color:#fff !important}.h0cTt [class*=options],.h0cTt [class*=existingPaymentMethods],.h0cTt [class*=box],.h0cTt [class*=optionsButtonsRow],.h0cTt [class*=paymentMethod]{max-width:100% !important}.h0cTt [class*=optionsClientOnboarding],.h0cTt [class*=bgClientOnboarding]{width:100% !important}.h0cTt [class*=addPaymentMethod]{margin-top:16px !important}.DcjUP{display:flex;flex-direction:column;gap:12px;padding-top:16px}.DcjUP.vlvzv{padding:0 4px}.a_zCb{flex-shrink:0;padding:0 4px}.gq_Kb{text-align:center;color:#282863}.uSWLM{align-self:center}.R_hyk{display:flex;align-items:center;justify-content:center;width:100%;min-height:100vh;padding:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"pageWrapper": `OVtii`,
	"pageWrapperMobile": `n8EgC`,
	"page": `BysS9`,
	"pageMobile": `snM2k`,
	"mobileHeaderWrapper": `tH4d7`,
	"leftPanel": `USkPP`,
	"leftPanelMobile": `Erj_x`,
	"rightPanel": `eAoXL`,
	"rightPanelMobile": `RAb5u`,
	"rightPanelTop": `KOXbp`,
	"rightPanelTitle": `AjPTn`,
	"paymentCard": `h0cTt`,
	"rightPanelBottom": `DcjUP`,
	"rightPanelBottomMobile": `vlvzv`,
	"mobilePayNowSticky": `a_zCb`,
	"disclaimer": `gq_Kb`,
	"bankSecurity": `uSWLM`,
	"skeleton": `R_hyk`
};
export default ___CSS_LOADER_EXPORT___;
